import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1228px;
  margin: 32px auto;
`;

export default Wrapper;
